<ng-container *ngIf="enabled$ | async">
  <section
    class="practice-agent-widget"
    [class.visible]="visible$ | async"
    [class.collapsed]="collapsed"
    [class.sidebar-open]="sidebarOpen$ | async"
    [class.wide-sidebar-open]="wideSidebarOpen$ | async"
    [attr.aria-hidden]="(visible$ | async) ? null : true"
    aria-label="Practice Agent">
    <iframe
      #practiceAgentIframe
      class="practice-agent-frame"
      [src]="widgetUrl"
      title="Practice Agent"
      sandbox="allow-scripts allow-same-origin allow-forms"
      referrerpolicy="no-referrer"
      (load)="onIframeLoad()"
      (error)="bridgeService.handleIframeError()">
    </iframe>
    <div class="widget-controls">
      <button
        mat-icon-button
        class="widget-control"
        type="button"
        [matTooltip]="collapsed ? 'Expand Practice Agent cards' : 'Collapse Practice Agent cards'"
        (click)="toggleCollapsed()"
        [attr.aria-label]="collapsed ? 'Expand Practice Agent cards' : 'Collapse Practice Agent cards'"
        [attr.aria-expanded]="!collapsed">
        <mat-icon>{{ collapsed ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
      </button>
      <button
        mat-icon-button
        class="widget-control"
        type="button"
        [matTooltip]="'Snooze for ' + bridgeService.snoozeDurationLabel"
        (click)="snooze()"
        [attr.aria-label]="'Snooze Practice Agent for ' + bridgeService.snoozeDurationLabel">
        <mat-icon>snooze</mat-icon>
      </button>
      <button
        mat-icon-button
        class="widget-control"
        type="button"
        matTooltip="Close Practice Agent"
        (click)="dismiss()"
        aria-label="Close Practice Agent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </section>
</ng-container>
